import { keyframes, styled } from "goober";
import type { ComponentProps, ReactNode } from "react";
import { Noodle } from "../Noodle";

const fadeInSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: stretch;
  margin-left: 13.5px;
  max-width: 100%;
  overflow: hidden;
  animation: ${fadeInSlideUp} var(--motion-fast) var(--ease-out);
`;

const Inner = styled("div")`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  overflow: hidden;
`;

const NoodleColumn = styled("div")`
  width: 10.5px;
  align-self: stretch;
  display: flex;
`;

export function ToolRow({
  variant,
  children,
}: {
  variant: ComponentProps<typeof Noodle>["variant"];
  children: ReactNode;
}) {
  return (
    <Container>
      <NoodleColumn>
        <Noodle gridSize={7} variant={variant} />
      </NoodleColumn>
      <Inner>{children}</Inner>
    </Container>
  );
}
